class VideoInView extends HTMLElement {
    constructor() {
      super();
      this._videoWrap = null;
      this._video = null;
    }
  
    static ensurePlayingProperty() {
      if (!HTMLMediaElement.prototype.hasOwnProperty('playing')) {
        Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
          get: function () {
            return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
          },
        });
      }
    }
  
    connectedCallback() {
      VideoInView.ensurePlayingProperty();
  
      this._videoWrap = this.querySelector('.video-wrap');
      if (this._videoWrap) {
        this._video = this._videoWrap.querySelector('video');
  
        whenReady('ClassWatcher', () => {
          new ClassWatcher(
            this._videoWrap,
            'in-view',
            () => this._handleInView(),
            () => this._handleOutOfView()
          );
        });
      }
    }
  
    disconnectedCallback() {
      if (this._video) {
        this._video.pause();
        this._video.removeAttribute('controls');
      }
    }
  
    _handleInView() {
      if (this._video) {
        this._video.setAttribute('controls', 'controls');
        this._video.play();
      }
    }
  
    _handleOutOfView() {
      if (this._video) {
        this._video.removeAttribute('controls');
        this._video.pause();
      }
    }
  }
  
  if (!window.customElements.get('video-in-view')) {
      customElements.define('video-in-view', VideoInView);
  }    